import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

import type { RootState } from "@/store";

type SecretsReducerType = {
  search: string;
  customerId: Nullable<string>;
};

const initialState: SecretsReducerType = {
  search: "",
  customerId: null,
};

const secretsSlice = createSlice({
  name: "admin/secrets",
  initialState,
  reducers: {
    setSearch(state, action: PayloadAction<string>) {
      state.search = action.payload;
    },
    setCustomerId(state, action: PayloadAction<Nullable<string>>) {
      state.customerId = action.payload;
    },
    resetFilters: () => initialState,
  },
});

export const { setSearch, setCustomerId, resetFilters } = secretsSlice.actions;
export const adminSecretsSelector = (state: RootState) => state.admin.secrets;
export default secretsSlice.reducer;
